export default __webpack_public_path__ + "static/media/manjeet.9b07aa85.jpg";